export class ErrorTrade {
  id: number;
  tradeId: string;
  orderId: string;
  accountId: string;
  instrument: string;
  base: string;
  term: string;
  dealtRate: number;
  quantity: number;
  valueDate: number;
  executionTime: number;
  isBuy: boolean;
  isMaker: boolean;
}
